import { useAppStore } from './app'
import pinia from './pinia'

const store = useAppStore(pinia)

export { pinia, useAppStore }
export default store
